<!-- ['facebook','x','pinterest','linkedin','reddit','tumblr','mix','viber','vk','telegram','messenger','whatsapp','xing','line','sms','email','print','copy'] -->
<div *ngIf="state$ | async; let state" class="sb-group sb-{{theme}}">
    @for(button of state.selectedButtons; track button) {
    <share-button [button]="button" [theme]="theme" [url]="url" [title]="title ?? null" [description]="description"
                  [image]="image" [tags]="tags" [autoSetMeta]="autoSetMeta" [showIcon]="showIcon" [showText]="showText"
                  [size]="size" (opened)="share($event)" (closed)="closed.emit()" [disabled]="disabled">
    </share-button>
    }
</div>